import {BaseModel} from '../../core/base/base-model';
import {Partner} from './cameralla-partner.model';

export class PhotoOrder extends BaseModel {
    selectedBrowse: {name: string, value: string};
    selectedOrder: {name: string, value: string};
    selectedRating: {name: string, value: string};
    selectedTimeFrame: {name: string, value: string};
    selectedPartner: Partner;

    readonly timeFrames = [
        //{name: 'Today', value: 'today'},
        {name: 'Last 24 hours', value: 'last24Hours'},
        {name: 'Last 7 days', value: 'last7Days'},
        {name: 'Last 30 days', value: 'last30Days'},
        //{name: 'This month', value: 'month'},
        {name: 'This year', value: 'year'},
        {name: 'All time', value: 'allTime'}
    ];
    readonly browses = [
        {name: 'Most Recent', value: 'create_at'},
        {name: 'Reviews', value: 'commentsCount'},
        {name: 'Stars', value: 'starsCount'},
        {name: 'Views', value: 'viewsCount'},
        // {name: 'Likes', value: 'likesCount'},
        // {name: 'Highest Rated', value: 'ratings'}
    ];
    readonly orders = [
        {name: 'Ascending', value: 'ASC'},
        {name: 'Descending', value: 'DESC'}
    ];
    readonly ratings = [
        {name: 'Total Avg.', value: 'overal'},
        {name: 'General', value: 'general'},
        {name: 'Vision', value: 'vision'},
        {name: 'Composition', value: 'composition'},
        {name: 'Camera Settings', value: 'cameraSettings'},
        {name: 'Editing', value: 'editing'},
        {name: 'Presentation', value: 'presentation'}
    ];

    constructor() {
        super();
        this.selectedBrowse = {name: 'Most Recent', value: 'create_at'};
        this.selectedOrder = {name: 'Descending', value: 'DESC'};
        this.selectedRating = {name: 'Total Avg.', value: 'overal'};
        this.selectedTimeFrame = {name: 'All time', value: 'allTime'};
    }
}
